<div class="font-poppins">
  <div
    class="academy-viewport-loader"
    *ngIf="isLoading && academyFormVisible"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="academy-viewport-loader-inner">
      <nz-spin
        nzSize="large"
        [nzSpinning]="true"
        [nzTip]="
          Uploadprogress === 0
            ? 'Please wait...'
            : 'Upload in progress ' + Uploadprogress + '%'
        "
      ></nz-spin>
    </div>
  </div>
  <nz-card
    *ngIf="
      !detailVisible &&
      !academyFormVisible &&
      !academyCourseFormVisible &&
      !quizFormVisible &&
      !quizDetail
    "
    style="min-height: 400px"
  >
    <div nz-row></div>
    <div class="row m-b-30 d">
      <div class="col-lg-7">
        <div class="d-md-flex">
          <div class="m-b-10 m-r-20">
            <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
              <input
                type="text"
                nz-input
                placeholder="Search"
                (keyup)="onKeyUp(searchBox.value)"
                [(ngModel)]="searchTerm"

                #searchBox
              />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <a nz-icon class="opacity-05" (click)="resetSearch()">
                <i nz-icon nzType="close" class="opacity-05"></i>
              </a>
            </ng-template>
            <ng-template #prefixTemplate>
              <i nz-icon nzType="search" class="opacity-05"></i>
            </ng-template>
          </div>
          <div class="m-b-10 m-r-10">
            <button
              nz-button
              nz-popover
              [nzPopoverContent]="popoverContent"
              nzPopoverTrigger="click"
              nzPopoverPlacement="bottom"
              [(nzPopoverVisible)]="filterVisible"
              (nzPopoverVisibleChange)="onPopoverVisibleChange($event)"
              class="btn-outline resource-btn"
              style="text-align: center"
            >
              <!-- <button
              nz-button
              nz-popover
              nzPopoverTrigger="click"
              [nzPopoverContent]="content"
              nzPopoverPlacement="bottom"
              [(nzPopoverVisible)]="filterVisible"
              class="btn-outline resource-btn"
              style="text-align: center"
            > -->
              
            
            <span *ngIf="!this.isArchived">All Courses</span>
            <span *ngIf="this.isArchived">Archived</span>
            <i
                nz-icon
                nzType="caret-down"
                style="position: relative; top: 1px; left: -3px"
                nzTheme="outline"
              ></i>
            </button>
            <ng-template
              class="filter"
              style="text-align: left; padding: 0px !important"
              #popoverContent
            >
              <div class="">
                <div nz-row nzGutter="24" style="padding-top: 10px;">
                  <div
                    nz-col
                    class="gutter-row"
                    nzSpan="24"
                    style="padding-bottom: 15px"
                  >
                    <span class="filter-heading">Show courses that are</span>
                  </div>
                </div>
              </div>
              <div style="height: 40px" nz-row>
                <div
                  style="color: #2d2d35; font-family: Poppins !important"
                  nz-col
                  nzSpan="24"
                >
                  <!-- <label nz-checkbox [(ngModel)]="isUsedInLast30Days"
                    >Used in last 30 days</label
                  >
                  <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider> -->
                  <!-- <label nz-checkbox [(ngModel)]="active">Active</label>
                  <nz-divider
                    style="
                      margin-top: 5px !important;
                      margin-bottom: 10px !important;
                    "
                  ></nz-divider> -->
                  <label nz-checkbox [(ngModel)]="archived">Archived</label>
                </div>
              </div>
              <div nz-row>
                <div
                  nz-col
                  nzSpan="24"
                  class="d-flex align-items-center justify-content-between"
                >
                  <span (click)="clickFilter()" class="cancel-label"
                    >Cancel</span
                  >
                  <button
                    class="btn-fill"
                    nz-button
                    nzType="default"
                    nzSize="small"
                    (click)="applyFilters()"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="d-md-flex justify-content-end">
          <!-- <div class="m-b-10 m-r-10">
            <nz-radio-group class="m-r-10">
              <label
                nz-radio-button
                nzValue="mailView"
                nzTooltipTitle="Mail View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i class="font-size-16" nz-icon nzType="mail" theme="fill"></i>
              </label>
              <label
                nz-radio-button
                nzValue="excelView"
                nzTooltipTitle="Excel View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="file-excel"
                  theme="fill"
                ></i>
              </label>
              <label
                nz-radio-button
                nzValue="printView"
                nzTooltipTitle="Print View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="printer"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
          <!-- <div class="m-b-10 m-r-20">
            <nz-radio-group>
              <label
                nz-radio-button
                nzValue="cardView"
                nzTooltipTitle="Card View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="appstore"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->

          <button
            nz-button=""
            nztype=" primary"
            class="font-small-caps btn-custom-light"
            title="Delete"
            nz-wave="[object Object]"
            *ngIf="anyChecked"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to delete the selected courses?"
            (nzOnConfirm)="deleteCourse(null, true)"
            nzPopconfirmPlacement="topRight"
            style="margin-right: 10px"
          >
            <i class="font-size-16" nz-icon nzType="delete" theme="fill"></i>
          </button>
          <button
            nz-button
            nzType="default"
            class="btn-fill"
            (click)="openAcademyCourseForm()"
          >
            <i class="fa fa-plus button-plus-icon" aria-hidden="true"></i
            >&nbsp;NEW
          </button>
        </div>
      </div>
    </div>

    <div nz-row nzGutter="16">
      <div nz-col class="gutter-row" nzSpan="24">
        <nz-table
          #academyTable
          [nzData]="courseData"
          [nzPageSize]="20"
          [nzLoading]="showLoad"
        >
          <thead nzSingleSort>
            <tr class="data-row cursor-move">
              <th
                nzShowCheckbox
                [(nzChecked)]="allChecked"
                (nzCheckedChange)="checkAll($event)"
                [nzIndeterminate]="indeterminate"
                [nzDisabled]="this.isArchived"
              ></th>
              <ng-container *ngFor="let column of listOfColumns">
                <th
                  *ngIf="column.name !== ''"
                  [hidden]="column.name === 'Actions' && isArchived"
                  [nzSortOrder]="column.sortOrder"
                  [nzSortFn]="column.sortFn"
                  [nzSortDirections]="column.sortDirections"
                  [nzFilterMultiple]="column.filterMultiple"
                  [nzWidth]="column.colWidth"
                >
                  {{ column.name }}
                </th>
                <th *ngIf="column.name === ''">{{ column.name }}</th>
              </ng-container>
              <!-- <th
                *ngFor="let column of listOfColumns"
                [nzSortOrder]="column.sortOrder"
                [nzSortFn]="column.sortFn"
                [nzSortDirections]="column.sortDirections"
              >
                {{ column.name }}
              </th> -->
            </tr>
          </thead>
          <tbody  [@fadeIn]>
            <ng-template ngFor let-item [ngForOf]="academyTable.data">
              <tr
                style="cursor: pointer"
                (click)="displayChapters(item.course_id)"
                class="data-row cursor-move"
                [ngStyle]="{'opacity': this.isArchived ? '0.7' : '1'}"
              >
                <td
                  nzShowCheckbox
                  [(nzChecked)]="item.checked"
                  (nzCheckedChange)="refreshStatus()"
                  [nzIndeterminate]="item.indeterminate"
                  [nzDisabled]="this.isArchived"
                ></td>

                <td>
                  <div class="d-flex align-items-center">
                    <nz-avatar
                      [nzSize]="30"
                      nzIcon="user"
                      [nzSrc]="item.avatar"
                    ></nz-avatar>
                    <span class="m-l-10 m-b-0">{{ item.course_name }}</span>
                  </div>
                </td>
                <td>{{ item.chapters.length }}</td>
                <!-- <td>
                  <nz-badge
                    *ngIf="item.popularity == 'high'"
                    nzStatus="success"
                  ></nz-badge>
                  <nz-badge
                    *ngIf="item.popularity == 'medium'"
                    nzStatus="error"
                  ></nz-badge>
                  <nz-badge
                    *ngIf="item.status == 'Not enough data'"
                    nzStatus="processing"
                  ></nz-badge>
                  <span *ngIf="!item.popularity" class="text-capitalize">
                    <nz-badge nzStatus="success">high</nz-badge></span
                  >
                </td> -->
                <td>{{ item.uploaded_date | date : "MM/dd/yyyy" }}</td>
                <td>{{ item.expires_date | date : "MM/dd/yyyy" }}</td>
                
                <td>
                  <ng-container *ngIf="getDisplayTags(item.tag) as tags">
                    <ng-container *ngIf="tags.length > 0">
                      <ng-container *ngIf="tags.length <= 2; else moreTags">
                        <nz-tag
                          *ngFor="let tag of tags.slice(0, 2)"
                          [nzMode]="default"
                          [nzColor]="'#ededed'"
                        >
                          {{ tag.tag_name }}
                        </nz-tag>
                      </ng-container>
                      <ng-template #moreTags>
                        <span *ngFor="let tag of tags.slice(0, 2)">
                          <nz-tag [nzMode]="default" [nzColor]="'#ededed'">{{
                            tag.tag_name
                          }}</nz-tag>
                        </span>

                        <span
                          nz-popover
                          [nzPopoverContent]="moreContents"
                          nzPopoverPlacement="bottom"
                          (mouseenter)="updateMoreTagsContent(tags)"
                          (mouseleave)="resetMoreTagsContent()"
                        >
                          <nz-tag [nzMode]="default" [nzColor]="'#ededed'"
                            >+{{ tags.length - 2 }} more</nz-tag
                          >
                        </span>

                        <ng-template #moreContents>
                          <span *ngFor="let tag of moreTagsContent">
                            <nz-tag [nzMode]="default" [nzColor]="'#ededed'">{{
                              tag
                            }}</nz-tag>
                          </span>
                        </ng-template>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                </td>
                <!-- <td>
                  <nz-tag
                    *ngFor="let tag of item.tag; let i = index"
                    [nzMode]="default"
                    [nzColor]="'#ededed'"
                  >
                    {{ tag.tag_name }}
                  </nz-tag>
                </td> -->
                <td *ngIf="!this.isArchived">
                  <!-- <span class="data-row-action"> -->
                    <span class="">
                    <a
                      class="m-r-5"
                      nz-button
                      nzType="default"
                      nzShape="circle"
                      nz-tooltip
                      nzTooltipTitle="Edit"
                      (click)="$event.stopPropagation(); fillAcademyCourseForm(item)"
                    >
                      <i
                        nz-icon
                        nzType="edit"
                        theme="outline"
                      ></i>
                    </a>
                    <button
                      type="button"
                      nz-button
                      nzType="default"
                      nzShape="circle"
                      class="m-r-5"
                      nz-tooltip
                      nzTooltipTitle="Notify incomplete users"
                      nz-popconfirm
                      [nzPopconfirmTitle]="
                        'Send notification to all users who have not completed &quot;' +
                        item.course_name +
                        '&quot;?'
                      "
                      (click)="$event.stopPropagation()"
                      (nzOnConfirm)="sendCourseIncompleteNotification(item)"
                    >
                      <i nz-icon nzType="bell" theme="outline"></i>
                    </button>
                    <button
                      type="button"
                      nz-button
                      nzType="default"
                      nzShape="circle"
                      nz-tooltip
                      nzTooltipTitle="Delete"
            
                      nz-popconfirm
                      nzPopconfirmTitle="Are you sure you want to delete this course?"
                      (click)="$event.stopPropagation()"
                      (nzOnConfirm)="deleteCourse(item.course_id)"
                    >
                      <i
                        nz-icon
                        nzType="delete"
                        theme="outline"
                    
                      ></i>
                    </button>
                  </span>
                </td>
                <!-- <td>
                  <span class="data-row-action">
                    <i
                      nz-icon
                      nzType="edit"
                      nzTheme="outline"
                      nz-tooltip
                      nzTooltipTitle="Edit"
                      (click)="fillAcademyCourseForm(item)"
                      class="m-r-10"
                    ></i>
                    <i
                      nz-icon
                      nzType="delete"
                      theme="outline"
                      nz-popconfirm
                      nzPopconfirmTitle="Are you sure you want to delete this course?"
                      (nzOnConfirm)="deleteCourse(item.course_id)"
                    ></i>
                  </span>
                </td> -->
              </tr>
            </ng-template>
          </tbody>
        </nz-table>
      </div>
    </div>
  </nz-card>

  <nz-card *ngIf="academyFormVisible" class="chapter-form-card">
    <nz-spin class="chapter-form-spin" [nzSpinning]="isLoading">
      <div nz-row nzGutter="16">
        <div
          nz-col
          class="gutter-row"
          nzSpan="24"
          style="text-align: right; width: 100%; height: 20px"
        >
          <a
            title="Cancel"
            (click)="this.checkFormStates()"
            style="float: right; margin-bottom: 20px"
            ><i nz-icon nzType="close" theme="outline"></i
          ></a>
        </div>
      </div>
      <div nz-row class="chapter-form-layout">
        <div nz-col nzSpan="12" class="chapter-form-fields">
          <form nz-form nzLayout="vertical" [formGroup]="academyChapterForm">
            <div nz-row>
              <div nz-col nzSpan="11">
                <nz-form-item>
                  <nz-form-label nzRequired>Chapter Name</nz-form-label>
                  <nz-form-control
                    _ngcontent-jfp-c14=""
                    class="ng-tns-c16-67 ant-form-item-control-wrapper ng-star-inserted ant-col-24"
                  >
                    <div class="ant-form-item-control">
                      <span class="ant-form-item-children">
                        <input
                          _ngcontent-jfp-c14=""
                          nz-input=""
                          placeholder="Chapter Name"
                          formControlName="chapter_name"
                          nzSize="medium"
                          class="ant-input ng-untouched ng-pristine ng-invalid" /><span
                          class="ant-form-item-children-icon"
                        >
                        </span>
                        <span class="text-danger" *ngIf="academyChapterForm.get('chapter_name')?.errors?.['required'] && academyChapterForm.get('chapter_name')?.touched">Chapter name is required.</span>
                      </span>
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="1">&nbsp;</div>
              <div nz-col nzSpan="11">
                <nz-form-item>
                  <nz-form-label nzRequired>Short Description</nz-form-label>
                  <nz-form-control
                    _ngcontent-jfp-c14=""
                    class="ng-tns-c16-67 ant-form-item-control-wrapper ng-star-inserted ant-col-24"
                  >
                    <div class="ant-form-item-control">
                      <span class="ant-form-item-children">
                        <input
                          _ngcontent-jfp-c14=""
                          nz-input=""
                          placeholder="Description"
                          formControlName="description"
                          nzSize="medium"
                          class="ant-input ng-untouched ng-pristine ng-invalid" /><span
                          class="ant-form-item-children-icon"
                        >
                        </span>
                        <span class="text-danger" *ngIf="academyChapterForm.get('description')?.errors?.['required'] && academyChapterForm.get('description')?.touched">Description is required.</span>
                      </span>
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="11">
                <nz-form-item>
                  <nz-form-label>Tag</nz-form-label>
                  <nz-form-control>
                    <nz-select
                      nzAllowClear
                      class="ant-col-30 m-r-10"
                      nzMode="tags"
                      nzPlaceHolder="Tags"
                      formControlName="tag"
                      nzTitle="Select Tag"
                      (ngModelChange)="
                        onTagSelectionChange('tag', academyChapterForm, $event)
                      "
                    >
                      <nz-option
                        *ngFor="let option of tagChapterFilterList"
                        [nzLabel]="option.text"
                        [nzValue]="option.value"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="23">
                <nz-form-item>
                  <nz-form-label nzRequired>Content</nz-form-label>
                  <nz-form-control>
                    <quill-editor
                      class="chapter-content-editor"
                      formControlName="content"
                      [modules]="chapterContentEditorModules"
                      [styles]="{ 'min-height': '160px' }"
                      [sanitize]="false"
                      format="html"
                      trackChanges="all"
                      placeholder="Enter text here..."
                      (onEditorCreated)="onChapterContentEditorCreated($event)"
                    ></quill-editor>
                    <span class="text-danger" *ngIf="academyChapterForm.get('content')?.errors?.['required'] && academyChapterForm.get('content')?.touched">Content is required.</span>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="23">
                <nz-form-item>
                  <nz-form-label>
                    Attachments
                    <span class="infoTextSpan">
                      (Can be multiple &amp; Only PDF, Images, MP4 &amp; MOV video files are allowed)
                    </span>
                  </nz-form-label>
                  <nz-form-control>
                    <app-taiga-chapter-dropzone
                      [loading]="isLoading"
                      (filesDropped)="addChapterAttachmentFiles($event)"
                      (filesRejected)="onAttachmentFilesRejected()"
                    ></app-taiga-chapter-dropzone>

                    <div
                      class="chapter-attachment-table"
                      *ngIf="getActiveChapterAttachments().length > 0"
                    >
                      <div class="chapter-attachment-header">
                        <div class="chapter-attachment-col chapter-attachment-col-order"></div>
                        <div class="chapter-attachment-col chapter-attachment-col-name">
                          File Name
                        </div>
                        <div class="chapter-attachment-col chapter-attachment-col-type">
                          Type
                        </div>
                        <div class="chapter-attachment-col chapter-attachment-col-position">
                          Position
                        </div>
                        <div class="chapter-attachment-col chapter-attachment-col-skippable">
                          Skippable
                        </div>
                        <div class="chapter-attachment-col chapter-attachment-col-actions"></div>
                      </div>

                      <div
                        class="chapter-attachment-row"
                        *ngFor="
                          let attachment of getActiveChapterAttachments();
                          let i = index
                        "
                      >
                        <div class="chapter-attachment-col chapter-attachment-col-order">
                          <div class="chapter-attachment-order-controls">
                            <button
                              nz-button
                              nzType="text"
                              nzSize="small"
                              [disabled]="i === 0"
                              (click)="moveChapterAttachmentUp(i)"
                            >
                              <i nz-icon nzType="arrow-up" nzTheme="outline"></i>
                            </button>
                            <button
                              nz-button
                              nzType="text"
                              nzSize="small"
                              [disabled]="
                                i === getActiveChapterAttachments().length - 1
                              "
                              (click)="moveChapterAttachmentDown(i)"
                            >
                              <i nz-icon nzType="arrow-down" nzTheme="outline"></i>
                            </button>
                          </div>
                        </div>

                        <div class="chapter-attachment-col chapter-attachment-col-name">
                          <div class="chapter-attachment-filename-input-wrap">
                            <input
                              nz-input
                              class="chapter-attachment-filename-input"
                              [(ngModel)]="attachment.file_name"
                              [ngModelOptions]="{ standalone: true }"
                              (blur)="onAttachmentFileNameBlur(attachment)"
                              placeholder="Enter file name"
                            />
                          </div>
                        </div>

                        <div class="chapter-attachment-col chapter-attachment-col-type">
                          <span
                            class="chapter-attachment-type-icon"
                            nz-tooltip
                            [nzTooltipTitle]="getAttachmentFileTypeLabel(attachment.file_type)"
                          >
                            <i
                              *ngIf="getAttachmentFileTypeIcon(attachment.file_type) === 'file-pdf'"
                              nz-icon
                              nzType="file-pdf"
                              nzTheme="twotone"
                              [twoToneColor]="'#ff4d4f'"
                            ></i>
                            <i
                              *ngIf="getAttachmentFileTypeIcon(attachment.file_type) === 'file-image'"
                              nz-icon
                              nzType="file-image"
                              nzTheme="twotone"
                              [twoToneColor]="'#1890ff'"
                            ></i>
                            <i
                              *ngIf="getAttachmentFileTypeIcon(attachment.file_type) === 'video-camera'"
                              nz-icon
                              nzType="video-camera"
                              nzTheme="twotone"
                              [twoToneColor]="'#722ed1'"
                            ></i>
                            <i
                              *ngIf="getAttachmentFileTypeIcon(attachment.file_type) === 'file'"
                              nz-icon
                              nzType="file"
                              nzTheme="outline"
                            ></i>
                          </span>
                        </div>

                        <div class="chapter-attachment-col chapter-attachment-col-position">
                          <nz-select
                            class="chapter-attachment-position-select"
                            [(ngModel)]="attachment.display_position"
                            [ngModelOptions]="{ standalone: true }"
                            style="width: 100%"
                          >
                            <nz-option
                              *ngFor="let option of displayPositionOptions"
                              [nzLabel]="option.label"
                              [nzValue]="option.value"
                            ></nz-option>
                          </nz-select>
                        </div>

                        <div class="chapter-attachment-col chapter-attachment-col-skippable">
                          <label
                            nz-checkbox
                            [(ngModel)]="attachment.is_skippable"
                            [ngModelOptions]="{ standalone: true }"
                            [nzDisabled]="!isVideoAttachment(attachment)"
                            nz-tooltip
                            [nzTooltipTitle]="
                              isVideoAttachment(attachment)
                                ? null
                                : 'Skippable is only available for video files'
                            "
                          ></label>
                        </div>

                        <div class="chapter-attachment-col chapter-attachment-col-actions">
                          <div class="chapter-attachment-action-btns">
                            <button
                              *ngIf="canPreviewAttachment(attachment)"
                              nz-button
                              nzType="default"
                              nzShape="circle"
                              class="chapter-attachment-preview-btn"
                              nz-tooltip
                              nzTooltipTitle="Preview"
                              (click)="previewAttachment($event, attachment)"
                            >
                              <i nz-icon nzType="eye" nzTheme="outline"></i>
                            </button>
                            <button
                              nz-button
                              nzType="default"
                              nzShape="circle"
                              nz-tooltip
                              nzTooltipTitle="Delete"
                              (click)="removeChapterAttachment(attachment)"
                            >
                              <i nz-icon nzType="delete" nzTheme="outline"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <!-- <div nz-row>
              <div nz-col nzSpan="9">
                <u style="padding: 2px"
                  ><a class="add-label" (click)="upload()">
                    <i nz-icon nzType="plus" theme="outline"></i> Add Attachment
                  </a></u
                >
              </div>
            </div> -->


            <div nz-row>
              <div nz-col nz-span="9" class="m-t-5">
                <label
                  nz-checkbox
                  class="chapter-quiz-checkbox"
                  [(ngModel)]="checkboxChecked"
                  [ngModelOptions]="{ standalone: true }"
                  (change)="onCheckboxChange($event)"
                  [disabled]="checkboxDisabled"
                >
                  <span class="chapter-quiz-checkbox-label"
                    >Add a test to evaluate the learnings</span
                  >
                </label>
              </div>
            </div>
          </form>
          
        </div>

        <div nz-col nzSpan="12" class="chapter-quiz-panel" *ngIf="checkboxChecked">
          <span style="font-size: 14px; color: #2d2d35; font-weight: 600"
            >Evaluate the learnings</span
          >
          <nz-card
            style="background-color: #ededed; border-radius: 15px"
            class="m-t-10 m-b-0"
          >
            <!-- <nz-radio-group [(ngModel)]="radioValue" nzSize="small">
              <label
                nz-radio-button
                nzValue="0"
                style="font-weight: 500"
                (click)="createManually()"
                >Create Manually</label
              >
              <label
                nz-radio-button
                nzValue="1"
                style="font-weight: 500"
                (click)="automaticManually()"
                >Generate Automatically</label
              >
            </nz-radio-group> -->

            <div *ngIf="automaticVisible">
              <nz-card
                style="border-radius: 15px; box-shadow: 5px 10px 18px #ededed"
                class="m-t-25"
              >
                <span style="font-size: 11px; color: #242833; font-weight: 600"
                  >Is EZ-111 a suitable option for the commercial applications and
                  outdoor uses?
                </span>
                <div class="m-t-10" style="font-weight: 500; color: #4d515d">
                  <label nz-checkbox
                    >Lorem ipsum dolor sit amet consectetur adipisicing
                    elit.</label
                  >
                  <label nz-checkbox
                    >Lorem ipsum dolor sit amet consectetur adipisicing
                    elit.</label
                  >
                  <label nz-checkbox
                    >Lorem ipsum dolor sit amet consectetur adipisicing
                    elit.</label
                  >
                  <label nz-checkbox
                    >Lorem ipsum dolor sit amet consectetur adipisicing
                    elit.</label
                  >
                </div>
              </nz-card>

              <nz-card
                style="border-radius: 15px; box-shadow: 5px 10px 18px #ededed"
                class="m-t-25"
              >
                <span style="font-size: 11px; color: #242833; font-weight: 600"
                  >Is EZ-111 a suitable option for the commercial applications and
                  outdoor uses?
                </span>
                <div class="m-t-10" style="font-weight: 500; color: #4d515d">
                  <label nz-checkbox
                    >Lorem ipsum dolor sit amet consectetur adipisicing
                    elit.</label
                  >
                  <label nz-checkbox
                    >Lorem ipsum dolor sit amet consectetur adipisicing
                    elit.</label
                  >
                  <label nz-checkbox
                    >Lorem ipsum dolor sit amet consectetur adipisicing
                    elit.</label
                  >
                  <label nz-checkbox
                    >Lorem ipsum dolor sit amet consectetur adipisicing
                    elit.</label
                  >
                </div>
              </nz-card>
            </div>

            <div *ngIf="createVisible">
              <nz-card
                style="border-radius: 15px; box-shadow: 5px 10px 18px #ededed"
                class="m-t-25"
              >
                <form nz-form [formGroup]="questionForm">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="6" nzRequired
                      >Quiz Name:</nz-form-label
                    >
                    <nz-form-control [nzSpan]="14">
                      <input
                        nz-input
                        formControlName="quiz_name"
                        placeholder="Enter the quiz name"
                      />
                    </nz-form-control>
                  </nz-form-item>

                  <div
                    class="form-item-padding"
                    style="margin-bottom: 10px; width: 100%; padding-right: 20px"
                  >
                    <div
                      class="scroller treatment-scroller"
                      id="prodContainerTop"
                      style="max-height: 600px; overflow: auto"
                    >
                      <ng-container formArrayName="questions">
                        <div
                          *ngFor="
                            let question of questionForm.get('questions')
                              .controls;
                            let i = index
                          "
                          [formGroupName]="i"
                        >
                          <nz-form-item>
                            <nz-form-label [nzSpan]="6" nzRequired
                              >Question {{ i + 1 }}:</nz-form-label
                            >
                            <nz-form-control [nzSpan]="14">
                              <input
                                nz-input
                                formControlName="question_text"
                                placeholder="Enter the question text"
                              />
                            </nz-form-control>
                          </nz-form-item>

                          <ng-container formArrayName="options">
                            <div
                              *ngFor="
                                let option of question.get('options').controls;
                                let j = index
                              "
                              [formGroupName]="j"
                            >
                              <nz-form-item>
                                <nz-form-label [nzSpan]="6"
                                  ><label
                                    nz-checkbox
                                    formControlName="is_correct_option"
                                    (change)="uncheckOtherOptions(i, j)"
                                  ></label
                                ></nz-form-label>
                                <nz-form-control [nzSpan]="14">
                                  <input
                                    nz-input
                                    formControlName="option_text"
                                    [placeholder]="'Enter Option ' + (j + 1)"
                                  />
                                </nz-form-control>
                              </nz-form-item>
                            </div>
                          </ng-container>

                          <nz-form-item>
                            <nz-form-control [nzSpan]="6" [nzOffset]="6" >
                              <u style="padding: 2px">
                                <a
                                  class="delete-label"
                                  (click)="questions.length === 1 ? showWarning() :deleteQuestion(i)"
                                  [disabled]="questions.length === 1"

                                >
                                  <i nz-icon nzType="delete" theme="outline"></i>
                                </a>
                              
                              </u>
                              
                            </nz-form-control>
                          </nz-form-item>
                        </div>
                      </ng-container>
                    </div>
                  </div>

                  <nz-form-item>
                    <nz-form-control [nzSpan]="14" [nzOffset]="6">
                      <u style="padding: 2px"
                        ><a class="add-label" (click)="addQuestion()">
                          <i nz-icon nzType="plus" theme="outline"></i> Add
                          Question
                        </a></u
                      >
                    </nz-form-control>
                  </nz-form-item>
                </form>
              </nz-card>
            </div>
          </nz-card>
        </div>

        <div nz-col nzSpan="24">
          <div
            style="
              padding-top: 20px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <button
              *ngIf="!updateModes"
              (click)="resetAcademyChapterForm()"
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-default"
            >
              <span>Reset</span>
            </button>

            <button
              *ngIf="updateModes"
              (click)="resetAcademyChapterUpdateForm()"
              nz-button=""
              nztype="default"
              class="ant-btn ant-btn-default"
            >
              <span>Reset</span>
            </button>

            <div style=" display: flex; align-items: center;">
              <!-- <span
                style="
                  font-size: 11px;
                  color: #545461;
                  font-weight: 500;
                  font-family: Poppins;
                "
                class="m-r-10"
                >Active</span
              > -->
              <!-- <form [formGroup]="activeForm">
                <nz-switch formControlName="is_active" (nzChange)="clickSwitch()" [disabled]="isLoading"></nz-switch>
              </form> -->
              <!-- <nz-switch [ngModel]="true"></nz-switch> -->
              <button
                nz-button=""
                nztype="default"
                class="cancelbtn-outline m-l-10"
                (click)="this.checkFormStates()"
                [disabled]="isLoading"
              >
                <span>Cancel</span>
              </button>
              <!-- || !this.questionForm.valid -->
              <!-- [disabled]="
                  !this.academyChapterForm.valid
                " -->
              <button
                nz-button=""
                nztype="default"
                *ngIf="!updateModes"
                class="ant-btn ant-btn-primary m-l-10"
                style="padding-left: 25px"
                [nzLoading]="isLoading"
                (click)="submitAcademyChapter()"
                [disabled]="!this.academyChapterForm.valid || (checkboxChecked && !this.questionForm.valid)"
                
              >
                Save
              </button>
              <button
                nz-button=""
                nztype="default"
                *ngIf="updateModes"
                
                class="ant-btn ant-btn-primary m-l-10"
                style="padding-left: 25px"
                [nzLoading]="isLoading"
                (click)="updateAcademyChapter()"
                [disabled]="!this.academyChapterForm.valid"
      
              >
              
                Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </nz-spin>
  </nz-card>

  <!-- Course Form -->
  <nz-card *ngIf="academyCourseFormVisible" class="course-form-card">
    <div nz-row nzGutter="16">
      <div
        nz-col
        class="gutter-row"
        nzSpan="24"
        style="text-align: right; width: 100%; height: 20px"
      >
        <a
          title="Cancel"
          (click)="this.checkFormState()"
          style="float: right; margin-bottom: 20px"
          ><i nz-icon nzType="close" theme="outline"></i
        ></a>
      </div>
    </div>
    <div nz-row nzGutter="24" class="course-form-layout">
      <div nz-col nzSpan="12" class="course-form-fields">
        <nz-spin nzTip="Please wait..." [nzSpinning]="isLoading">
          <form nz-form nzLayout="vertical" [formGroup]="academyCourseForm">
            <div nz-row [nzGutter]="16">
              <div nz-col nzSpan="12">
                <nz-form-item>
                  <nz-form-label nzRequired>Course Name</nz-form-label>
                  <nz-form-control>
                    <input
                      nz-input
                      formControlName="course_name"
                      placeholder="Course Name"
                      nzSize="medium"
                    />
                    <span
                      class="text-danger"
                      *ngIf="
                        academyCourseForm.get('course_name')?.errors?.['required'] &&
                        academyCourseForm.get('course_name')?.touched
                      "
                      >Course name is required.</span
                    >
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="12">
                <nz-form-item>
                  <nz-form-label for="timezone">Timezone</nz-form-label>
                  <nz-form-control>
                    <nz-select
                      nzShowSearch
                      nzAllowClear
                      formControlName="timezone"
                      nzPlaceHolder="Please select timezone"
                      name="timezone"
                      style="width: 100%"
                    >
                      <nz-option-group nzLabel="Current timezone">
                        <nz-option
                          [nzLabel]="userCurrentTimezone.display"
                          [nzValue]="userCurrentTimezone.value"
                        ></nz-option>
                      </nz-option-group>
                      <nz-option
                        *ngFor="let tz of timezones"
                        [nzLabel]="tz.display"
                        [nzValue]="tz.value"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="16">
              <div nz-col nzSpan="12">
                <nz-form-item>
                  <nz-form-label nzRequired>Expires Date</nz-form-label>
                  <nz-form-control>
                    <nz-date-picker
                      nzShowToday="false"
                      nzFormat="MM-dd-yyy"
                      formControlName="expires_date"
                      (ngModelChange)="onChange($event)"
                      style="width: 100%"
                    ></nz-date-picker>
                    <span
                      class="text-danger"
                      *ngIf="
                        academyCourseForm.get('expires_date')?.errors?.['required'] &&
                        academyCourseForm.get('expires_date')?.touched
                      "
                      >Expires date is required.</span
                    >
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="12">
                <nz-form-item>
                  <nz-form-label for="Category" nzRequired>
                    Course Category
                  </nz-form-label>
                  <nz-form-control>
                    <nz-select
                      formControlName="category_id"
                      name="Category"
                      nzPlaceHolder="Please select"
                      nzSize="small"
                      style="width: 100%"
                    >
                      <nz-option
                        *ngFor="let course of course_category"
                        [nzLabel]="course.name"
                        [nzValue]="course.course_category_id"
                      ></nz-option>
                    </nz-select>
                    <span
                      class="text-danger"
                      *ngIf="
                        academyCourseForm.get('category_id')?.errors?.['required'] &&
                        academyCourseForm.get('category_id')?.touched
                      "
                      >Category is required.</span
                    >
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="24">
                <nz-form-item>
                  <nz-form-label for="Tag">Tags</nz-form-label>
                  <nz-form-control>
                    <nz-select
                      formControlName="tag"
                      nzPlaceHolder="Please select"
                      nzSize="small"
                      nzMode="tags"
                      style="width: 100%"
                      (ngModelChange)="
                        onTagSelectionChange('tag', academyCourseForm, $event)
                      "
                    >
                      <nz-option
                        *ngFor="let option of tagCourseFilterList"
                        [nzLabel]="option.text"
                        [nzValue]="option.value"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="24">
                <nz-form-item>
                  <nz-form-label>Course Thumbnail</nz-form-label>
                  <nz-form-control>
                    <div class="course-thumbnail-upload">
                      <input
                        #courseThumbnailInput
                        type="file"
                        accept="image/*"
                        hidden
                        (change)="onCourseThumbnailSelected($event)"
                      />
                      <button
                        nz-button
                        nzType="default"
                        type="button"
                        (click)="courseThumbnailInput.click()"
                      >
                        <span nz-icon nzType="upload"></span>
                        {{
                          courseThumbnailPreviewUrl
                            ? 'Change Thumbnail'
                            : 'Select Thumbnail'
                        }}
                      </button>
                      <div
                        class="course-thumbnail-preview"
                        *ngIf="courseThumbnailPreviewUrl"
                      >
                        <img
                          [src]="courseThumbnailPreviewUrl"
                          alt="Course thumbnail preview"
                        />
                        <button
                          nz-button
                          nzType="default"
                          nzDanger
                          type="button"
                          class="m-t-10"
                          (click)="removeCourseThumbnail()"
                        >
                          Remove Thumbnail
                        </button>
                      </div>
                      <div class="text-muted m-t-5" *ngIf="!courseThumbnailPreviewUrl">
                        Upload an image to show on the Academy course card.
                      </div>
                    </div>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row [nzGutter]="16">
              <div nz-col nzSpan="12">
                <nz-form-item>
                  <nz-form-label>Send Notification</nz-form-label>
                  <nz-form-control>
                    <nz-select
                      formControlName="send_notification"
                      nzPlaceHolder="Please select"
                      (ngModelChange)="onSendNotificationChange($event)"
                      style="width: 100%"
                    >
                      <nz-option
                        *ngFor="let option of sendNotificationOptions"
                        [nzLabel]="option.label"
                        [nzValue]="option.value"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div nz-col nzSpan="12">
                <nz-form-item>
                  <nz-form-label>
                    Recurrence (Every x days)
                    <i
                      nz-icon
                      nzType="info-circle"
                      nzTheme="outline"
                      class="course-notification-info-icon"
                      nz-tooltip
                      nzTooltipTitle="Set the number of days for recurring notifications."
                    ></i>
                  </nz-form-label>
                  <nz-form-control>
                    <nz-select
                      formControlName="notification_recurrence"
                      nzPlaceHolder="Please select"
                      [nzDisabled]="
                        academyCourseForm.get('send_notification')?.value !== 1
                      "
                      style="width: 100%"
                    >
                      <nz-option
                        *ngFor="let option of notificationRecurrenceOptions"
                        [nzLabel]="option.label"
                        [nzValue]="option.value"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row>
              <div nz-col nzSpan="24" class="m-t-5">
                <label
                  nz-checkbox
                  [(ngModel)]="courseQuizChecked"
                  [ngModelOptions]="{ standalone: true }"
                  (change)="onCourseQuizCheckboxChange($event)"
                  [disabled]="courseQuizDisabled"
                >
                  <span class="course-quiz-checkbox-label"
                    >Add a Course level test to evaluate</span
                  >
                </label>
              </div>
            </div>

            <div nz-row class="course-form-actions">
              <div nz-col class="gutter-row" nzSpan="12">
                <button
                  *ngIf="!updateMode"
                  (click)="resetAcademyCourseForm()"
                  nz-button
                  nzType="default"
                >
                  <span>Reset</span>
                </button>
                <button
                  *ngIf="updateMode"
                  (click)="resetAcademyUpdateForm()"
                  nz-button
                  nzType="default"
                >
                  <span>Reset</span>
                </button>
              </div>
              <div
                nz-col
                class="gutter-row"
                nzSpan="12"
                style="text-align: right"
              >
                <button
                  nz-button
                  nzType="default"
                  class="cancelbtn-outline"
                  (click)="this.checkFormState()"
                >
                  <span>Cancel</span>
                </button>

                <button
                  nz-button
                  nzType="default"
                  [nzLoading]="isLoading"
                  *ngIf="!updateMode"
                  class="ant-btn ant-btn-primary m-l-10"
                  style="padding-left: 25px"
                  (click)="submitCourse()"
                  [disabled]="
                    !this.academyCourseForm.valid ||
                    (courseQuizChecked && !this.questionForm.valid)
                  "
                >
                  <span>Save</span>
                </button>

                <button
                  nz-button
                  nzType="default"
                  *ngIf="updateMode"
                  class="ant-btn ant-btn-primary m-l-10"
                  style="padding-left: 25px; padding-right: 25px"
                  (click)="updateAcademyCourse()"
                  [nzLoading]="isLoading"
                  [disabled]="
                    !this.academyCourseForm.valid ||
                    (courseQuizChecked && !this.questionForm.valid) ||
                    (!academyCourseForm.dirty && !questionForm.dirty)
                  "
                >
                  <span>Update</span>
                </button>
              </div>
            </div>
          </form>
        </nz-spin>
      </div>

      <div nz-col nzSpan="12" *ngIf="courseQuizChecked" class="course-quiz-panel">
        <span class="course-quiz-panel-title">Evaluate the learnings</span>
        <nz-card class="course-quiz-outer-card">
          <div *ngIf="createVisible">
            <nz-card class="course-quiz-inner-card">
              <form nz-form [formGroup]="questionForm">
                <nz-form-item>
                  <nz-form-label [nzSpan]="6" nzRequired
                    >Quiz Name:</nz-form-label
                  >
                  <nz-form-control [nzSpan]="14">
                    <input
                      nz-input
                      formControlName="quiz_name"
                      placeholder="Enter the quiz name"
                    />
                  </nz-form-control>
                </nz-form-item>

                <div class="course-quiz-questions">
                  <div
                    class="scroller treatment-scroller"
                    id="courseQuizContainer"
                  >
                    <ng-container formArrayName="questions">
                      <div
                        *ngFor="
                          let question of questionForm.get('questions')
                            .controls;
                          let i = index
                        "
                        [formGroupName]="i"
                      >
                        <nz-form-item>
                          <nz-form-label [nzSpan]="6" nzRequired
                            >Question {{ i + 1 }}:</nz-form-label
                          >
                          <nz-form-control [nzSpan]="14">
                            <input
                              nz-input
                              formControlName="question_text"
                              placeholder="Enter the question text"
                            />
                          </nz-form-control>
                        </nz-form-item>

                        <ng-container formArrayName="options">
                          <div
                            *ngFor="
                              let option of question.get('options').controls;
                              let j = index
                            "
                            [formGroupName]="j"
                          >
                            <nz-form-item>
                              <nz-form-label [nzSpan]="6">
                                <label
                                  nz-checkbox
                                  formControlName="is_correct_option"
                                  (change)="uncheckOtherOptions(i, j)"
                                ></label>
                              </nz-form-label>
                              <nz-form-control [nzSpan]="14">
                                <input
                                  nz-input
                                  formControlName="option_text"
                                  [placeholder]="'Enter Option ' + (j + 1)"
                                />
                              </nz-form-control>
                            </nz-form-item>
                          </div>
                        </ng-container>

                        <nz-form-item>
                          <nz-form-control [nzSpan]="6" [nzOffset]="6">
                            <u style="padding: 2px">
                              <a
                                class="delete-label"
                                (click)="
                                  questions.length === 1
                                    ? showWarning()
                                    : deleteQuestion(i)
                                "
                                [disabled]="questions.length === 1"
                              >
                                <i nz-icon nzType="delete" theme="outline"></i>
                              </a>
                            </u>
                          </nz-form-control>
                        </nz-form-item>
                      </div>
                    </ng-container>
                  </div>
                </div>

                <nz-form-item>
                  <nz-form-control [nzSpan]="14" [nzOffset]="6">
                    <u style="padding: 2px"
                      ><a class="add-label" (click)="addQuestion()">
                        <i nz-icon nzType="plus" theme="outline"></i> Add
                        Question
                      </a></u
                    >
                  </nz-form-control>
                </nz-form-item>
              </form>
            </nz-card>
          </div>
        </nz-card>
      </div>
    </div>
  </nz-card>

  <!-- Course Form -->

  <!-- CHAPTERS DETAIL -->
  <nz-card *ngIf="detailVisible">
    <div class="row m-b-30 d">
      <div class="col-lg-7">
        <div class="d-md-flex">
          <div class="m-b-10 m-r-20">
            <button
              title="Go Back"
              (click)="closeDetail()"
              nz-button
              nzType="default"
            >
              <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
            </button>
          </div>
          <div class="m-b-10 m-r-20">
            <nz-input-group [nzPrefix]="prefixTemplate" [nzSuffix]="suffixTemplate">
              <input
                type="text"
                nz-input
                placeholder="Search"
                (keyup)="onKeyUpChapter(chapterSearchBox.value)"
                [(ngModel)]="searchTermChapter"
                #chapterSearchBox
              />
            </nz-input-group>
            <ng-template #suffixTemplate>
              <a nz-icon class="opacity-05" (click)="resetSearchChapter()">
                <i nz-icon nzType="close" class="opacity-05"></i>
              </a>
            </ng-template>
            <ng-template #prefixTemplate>
              <i nz-icon nzType="search" class="opacity-05"></i>
            </ng-template>
          </div>
          <!-- <div class="m-b-10 m-r-10">
            <button
              nz-button
              nz-popover
              [nzPopoverContent]="content"
              nz-popover
              class="btn-outline resource-btn"
              style="text-align: center"
            >
              All Chapters<i
                nz-icon
                nzType="caret-down"
                style="position: relative; top: 1px; left: -3px"
                nzTheme="outline"
              ></i>
            </button>
          </div> -->
        </div>
      </div>
      <div class="col-lg-5">
        <div class="d-md-flex justify-content-end">
          <!-- <div class="m-b-10 m-r-10">
            <nz-radio-group class="m-r-10">
              <label
                nz-radio-button
                nzValue="mailView"
                nzTooltipTitle="Mail View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i class="font-size-16" nz-icon nzType="mail" theme="fill"></i>
              </label>
              <label
                nz-radio-button
                nzValue="excelView"
                nzTooltipTitle="Excel View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="file-excel"
                  theme="fill"
                ></i>
              </label>
              <label
                nz-radio-button
                nzValue="printView"
                nzTooltipTitle="Print View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="printer"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
          <!-- <div class="m-b-10 m-r-20">
            <nz-radio-group>
              <label
                nz-radio-button
                nzValue="cardView"
                nzTooltipTitle="Card View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="appstore"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
          <button
            nz-button=""
            nztype=" primary"
            class="font-small-caps btn-custom-light"
            title="Delete"
            nz-wave="[object Object]"
            *ngIf="anyCheckedChapter"
            nz-popconfirm
            nzPopconfirmTitle="Are you sure you want to delete the selected courses?"
            (nzOnConfirm)="deleteChapter(null, true)"
            nzPopconfirmPlacement="topRight"
            style="margin-right: 10px"
          >
            <i class="font-size-16" nz-icon nzType="delete" theme="fill"></i>
          </button>
          <button
            [disabled]="this.isArchived"
            [ngStyle]="{'opacity': this.isArchived ? '0.7' : '1'}"
            nz-button
            nzType="default"
            class="btn-outline resource-btn m-r-10"
            (click)="openCourseQuizFromDetail()"
          >
            {{
              selectedCourseRaw?.quizzes?.length
                ? 'Edit Course Quiz'
                : 'Add Course Quiz'
            }}
          </button>
          <button
            [disabled]="this.isArchived"
            [ngStyle]="{'opacity': this.isArchived ? '0.7' : '1'}"
            nz-button
            nzType="default"
            class="btn-fill"
            (click)="openAcademyForm()"
          >
            <i class="fa fa-plus button-plus-icon" aria-hidden="true"></i
            >&nbsp;NEW
          </button>
        </div>
      </div>
    </div>

    <div nz-row nzGutter="16">
      <div nz-col class="gutter-row" nzSpan="24">
        <nz-table
          #academyTableChapter
          [nzData]="selectedCourseChapters"
          [nzPageSize]="20"
          [nzLoading]="showLoad"
        >
          <thead nzSingleSort>
            <tr>
              <th
                nzShowCheckbox
                [(nzChecked)]="allChecked"
                (nzCheckedChange)="checkAllChapter($event)"
                [nzDisabled]="this.isArchived"
              ></th>
              <ng-container *ngFor="let column of listOfColumnsChapter">
                <th
                  *ngIf="column.name !== ''"
                  [hidden]="column.name === 'Actions' && isArchived"
                  [nzSortOrder]="column.sortOrder"
                  [nzSortFn]="column.sortFn"
                  [nzSortDirections]="column.sortDirections"
                  [nzFilterMultiple]="column.filterMultiple"
                  [nzWidth]="column.colWidth"
                  
                >
                  {{ column.name }}
                </th>
                <th *ngIf="column.name === ''">{{ column.name }}</th>
              </ng-container>
              <!-- <th nzShowSort nzSortKey="name">Chapter</th>
              <th nzShowSort nzSortKey="type">Engagement</th>
              <th nzShowSort nzSortKey="members">Tag</th>
              <th></th> -->
            </tr>
          </thead>
          <tbody  [@fadeIn]>
            <tr
              *ngFor="let item of academyTableChapter.data; let i = index"
              style="cursor: pointer"
              class="data-row cursor-move"
              [ngStyle]="{'opacity': this.isArchived ? '0.7' : '1'}"
            >
              <td
                nzShowCheckbox
                [(nzChecked)]="item.checked"
                (nzCheckedChange)="refreshChapterStatus()"
                [nzDisabled]="this.isArchived"
              ></td>
              <td
              (click)="fillAcademyChapterForm(item)"
              >
                <div class="d-flex align-items-center">
                  <span>{{ i + 1 }}.</span>
                  <span class="m-l-10 m-b-0">{{ item.chapter_name }}</span>
                </div>
              </td>
              <!-- <td>
                <nz-badge
                  *ngIf="item.engagement == 'high'"
                  nzStatus="success"
                ></nz-badge>
                <nz-badge
                  *ngIf="item.engagement == 'medium'"
                  nzStatus="error"
                ></nz-badge>
                <span *ngIf="!item.engagement" class="text-capitalize">
                  <nz-badge nzStatus="success">high</nz-badge></span
                >
              </td> -->
              <!-- <span class="text-capitalize">{{ item.engagement }}</span> -->

              <td
              (click)="fillAcademyChapterForm(item)"
              >
                <nz-tag
                  *ngFor="let tag of getDisplayTags(item.tag); let i = index"
                  [nzMode]="default"
                  [nzColor]="'#ededed'"
                >
                {{ tag.tag_name }}
              </nz-tag>
              

            </td>

              <td *ngIf="!this.isArchived">
                <!-- <span class="data-row-action"> -->
                  <span class="">
                  <!-- <a
                    class="m-r-5"
                    nz-button
                    nzType="default"
                    nzShape="circle"
                    nz-tooltip
                    nzTooltipTitle="Edit"
                  >
                    <i
                      nz-icon
                      nzType="edit"
                      theme="outline"
                      (click)="fillAcademyChapterForm(item)"
                    ></i>
                  </a> -->
                  <button
                    nz-button
                    nzType="default"
                    nzShape="circle"
                    nz-tooltip
                    nzTooltipTitle="Delete"
                  >
                    <i
                      nz-icon
                      nzType="delete"
                      theme="outline"
                      nz-popconfirm
                      nzPopconfirmTitle="Are you sure you want to delete this chapter?"
                      (nzOnConfirm)="deleteChapter(item.chapter_id)"
                    ></i>
                  </button>
                </span>
              </td>

              <!-- <td>
                <span class="data-row-action">
                  <i
                    nz-icon
                    nzType="edit"
                    nzTheme="outline"
                    (click)="fillAcademyChapterForm(item)"
                    class="m-r-15"
                  ></i>
                  <i
                    nz-icon
                    nzType="delete"
                    theme="outline"
                    nz-popconfirm
                    nzPopconfirmTitle="Are you sure delete this chapter?"
                    (nzOnConfirm)="deleteChapter(item.chapter_id)"
                  ></i>
                </span>
              </td> -->
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </nz-card>

  <nz-card *ngIf="quizDetail">
    <div class="row m-b-30 d">
      <div class="col-lg-7">
        <div class="d-md-flex">
          <div class="m-b-10 m-r-20">
            <button
              title="Go Back"
              (click)="closeDetail()"
              nz-button
              nzType="default"
            >
              <i nz-icon nzType="arrow-left" nzTheme="outline"></i>
            </button>
          </div>
          <div class="m-b-10 m-r-20">
            <nz-input-group [nzPrefix]="prefixTemplate">
              <input
                type="text"
                nz-input
                placeholder="Search"
                (keyup)="onKeyUp(searchBox.value)"
                #searchBox
              />
            </nz-input-group>
            <ng-template #prefixTemplate>
              <i nz-icon nzType="search" class="opacity-05"></i>
            </ng-template>
          </div>
          <div class="m-b-10 m-r-10">
            <button
              nz-button
              nz-popover
              [nzPopoverContent]="content"
              nz-popover
              class="btn-outline resource-btn"
              style="text-align: center"
            >
              All Chapters<i
                nz-icon
                nzType="caret-down"
                style="position: relative; top: 1px; left: -3px"
                nzTheme="outline"
              ></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="d-md-flex justify-content-end">
          <!-- <div class="m-b-10 m-r-10">
            <nz-radio-group class="m-r-10">
              <label
                nz-radio-button
                nzValue="mailView"
                nzTooltipTitle="Mail View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i class="font-size-16" nz-icon nzType="mail" theme="fill"></i>
              </label>
              <label
                nz-radio-button
                nzValue="excelView"
                nzTooltipTitle="Excel View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="file-excel"
                  theme="fill"
                ></i>
              </label>
              <label
                nz-radio-button
                nzValue="printView"
                nzTooltipTitle="Print View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="printer"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
          <!-- <div class="m-b-10 m-r-20">
            <nz-radio-group>
              <label
                nz-radio-button
                nzValue="cardView"
                nzTooltipTitle="Card View"
                nzTooltipPlacement="bottom"
                nz-tooltip
              >
                <i
                  class="font-size-16"
                  nz-icon
                  nzType="appstore"
                  theme="fill"
                ></i>
              </label>
            </nz-radio-group>
          </div> -->
          <button
            nz-button
            nzType="default"
            class="btn-fill"
            (click)="openAcademyForm()"
          >
            <i class="fa fa-plus button-plus-icon" aria-hidden="true"></i
            >&nbsp;NEW
          </button>
        </div>
      </div>
    </div>

    <div nz-row nzGutter="16">
      <div nz-col class="gutter-row" nzSpan="24">
        <nz-table #academyTable [nzData]="quizzesForChapter" [nzPageSize]="50">
          <thead nzSingleSort>
            <tr>
              <th nzShowCheckbox></th>
              <th nzShowSort nzSortKey="name">Quiz</th>
              <th nzShowSort nzSortKey="members">Tag</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of quizzesForChapter; let i = index"
              style="cursor: pointer"
              class="data-row cursor-move"
            >
              <td nzShowCheckbox></td>
              <td>{{ item.quiz_name }}</td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </nz-card>

  <nz-card *ngIf="quizFormVisible">
    <div>
      <nz-card>
        <form nz-form [formGroup]="questionForm">
          <nz-form-item>
            <nz-form-label [nzSpan]="6">Quiz Name:</nz-form-label>
            <nz-form-control [nzSpan]="14">
              <input
                nz-input
                formControlName="quiz_name"
                placeholder="Enter the quiz name"
              />
            </nz-form-control>
          </nz-form-item>

          <div
            class="form-item-padding"
            style="margin-bottom: 10px; width: 100%; padding-right: 20px"
          >
            <div
              class="scroller treatment-scroller"
              id="prodContainerTop"
              style="max-height: 600px; overflow: auto"
            >
              <ng-container formArrayName="questions">
                <div
                  *ngFor="
                    let question of questionForm.get('questions').controls;
                    let i = index
                  "
                  [formGroupName]="i"
                >
                  <nz-form-item>
                    <nz-form-label [nzSpan]="6"
                      >Question {{ i + 1 }}:</nz-form-label
                    >
                    <nz-form-control [nzSpan]="14">
                      <input
                        nz-input
                        formControlName="question_text"
                        placeholder="Enter the question text"
                      />
                    </nz-form-control>
                  </nz-form-item>

                  <ng-container formArrayName="options">
                    <div
                      *ngFor="
                        let option of question.get('options').controls;
                        let j = index
                      "
                      [formGroupName]="j"
                    >
                      <nz-form-item>
                        <input
                          type="checkbox"
                          [formControl]="option.get('is_correct_option')"
                        />

                        <nz-form-label [nzSpan]="6"
                          ><input
                            type="checkbox"
                            [formControl]="option.get('is_correct_option')"
                        /></nz-form-label>
                        <nz-form-control [nzSpan]="14">
                          <input
                            nz-input
                            formControlName="option_text"
                            [placeholder]="'Enter Option ' + (j + 1)"
                          />
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>

          <div style="margin-top: 10px" nz-row>
            <div nz-col nzSpan="24">
              <a
                (click)="addQuestion()"
                class="extra-label"
                style="text-decoration: underline"
              >
                <i nz-icon nzType="plus" theme="outline"></i> Add Question
              </a>
            </div>
          </div>
        </form>
      </nz-card>
    </div>
  </nz-card>
</div>
